import { render, staticRenderFns } from "./ReorderUserParams.vue?vue&type=template&id=b2ad1214&scoped=true"
import script from "./ReorderUserParams.vue?vue&type=script&lang=ts"
export * from "./ReorderUserParams.vue?vue&type=script&lang=ts"
import style0 from "./ReorderUserParams.vue?vue&type=style&index=0&id=b2ad1214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ad1214",
  null
  
)

export default component.exports